import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateMessagingOnRoute } from '../lib/clientMessaging';

/**
 * Route-change analytics bridge. PostHog handles its own SPA pageviews
 * (capture_pageview: 'history_change' in App.tsx); this covers the SDKs that
 * don't: Customer.io page events onto the person timeline, and Intercom's
 * "new page" update + launcher visibility allowlist. Renders nothing.
 */
export default function AnalyticsPageBridge() {
  const location = useLocation();

  useEffect(() => {
    updateMessagingOnRoute(location.pathname);
  }, [location.pathname]);

  return null;
}
